import gql from 'graphql-tag';

/**
 * Data of the block project-extended-configuration (ADR 0006 D1): its 18 `solarPlant` fields.
 * Read through `Project.blocks.extendedConfiguration`, which checks the block's read permission.
 */
export const PROJECT_EXTENDED_CONFIGURATION_FIELDS = gql`
  fragment projectExtendedConfigurationFields on ProjectExtendedConfigurationBlock {
    id
    number
    solarPlant {
      cascadeConnectionState
      electricMeterCombinationState
      electricMeterDeregistrationState
      electricMeterMountingState
      houseFuseAmpere
      houseFuseState
      islandOperationIntended
      measuringConcept
      motorStartup
      netOutputStates
      networkSupplyManagementPermanentRestrictionState
      networkSupplyManagementState
      networkSupplyManagementXOverState
      networkSupplyType
      solarPlantType
      storageCouplingState
      wireCrossSectionMainBus
      yearlyPower
    }
  }
`;
